import { render } from "./orderList.vue?vue&type=template&id=4c4729eb"
import script from "./orderList.vue?vue&type=script&setup=true&lang=js"
export * from "./orderList.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/exhibitionManage/orderList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c4729eb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c4729eb', __exports__)) {
    console.log('reload')
    api.reload('4c4729eb', __exports__)
  }
  
  module.hot.accept("./orderList.vue?vue&type=template&id=4c4729eb", () => {
    console.log('re-render')
    api.rerender('4c4729eb', render)
  })

}


export default __exports__